module.exports = __webpack_public_path__ + "static/media/1f6c2.19901692.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f6c2.svg
// module id = 643
// module chunks = 1